import { columns } from './constants'
import { GetGameListTableData } from '@/modules/game/type'
import GameTypeSelector from '@/common/components/GameTypeSelector'
import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'

import { Combobox } from '@/common/ui/combobox'
import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetGameProviderList from '@/modules/game/api/hooks/useQueryGetGameProviderList'
import BatchAssignGameRtpPreset from './components/BatchAssignGameRtpPreset'

interface GameListTableProps {
	data: GetGameListTableData[]
	isLoading?: boolean
	total: number
}

export default function GameListTable({
	data,
	isLoading,
	total,
}: GameListTableProps) {
	const { selectedQuery, setSelectedQuery } = useTablePagination()
	const { data: providerData } = useQueryGetGameProviderList({
		skip: 0,
		take: 500,
	})

	const providerOptions = [
		{
			label: 'ทั้งหมด',
			value: '',
		},
		...(providerData?.data.map((provider) => ({
			label: provider.name || '',
			value: provider.name,
		})) || []),
	]

	return (
		<div className="space-y-4">
			<div className="flex flex-wrap items-center justify-between gap-2">
				<GameTypeSelector />
				<div className="flex flex-wrap items-center gap-2">
					<Combobox
						placeholder="เลือกค่ายเกม"
						options={providerOptions}
						value={selectedQuery}
						onValueChange={setSelectedQuery}
					/>
					<DataTableSearch placeHolder="ค้นหาเกม" />
					<DataTableResetFilter />
					<BatchAssignGameRtpPreset providers={providerData?.data || []} />
				</div>
			</div>
			<DataTablePaginate
				columns={columns}
				data={data}
				isLoading={isLoading}
				totalItems={total}
			/>
		</div>
	)
}
